/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TimeLineListArticleResponse } from "./TimeLineListArticleResponse";

export type TimeLineListArticleResponseApiRespoonse = {
  data?: TimeLineListArticleResponse;
  status?: TimeLineListArticleResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace TimeLineListArticleResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
